import { FC } from "react";
import { StandaloneMarkdownText } from "./markdown-text";

interface Props {
  content: string;
}

/**
 * Simple user message bubble component.
 * Displays user messages in a rounded bubble with markdown support.
 *
 * @component
 * @example
 * <UserMessageBubble content="What is the project timeline?" />
 */
const UserMessageBubble: FC<Props> = ({ content }) => (
  // Keep the bubble readable and constrained, while allowing markdown formatting
  <div className="bg-muted text-foreground col-start-2 wrap-break-word rounded-3xl px-5 py-2.5 min-w-0 max-w-full overflow-wrap-anywhere">
    <StandaloneMarkdownText>
      {content}
    </StandaloneMarkdownText>
  </div>
);

export default UserMessageBubble;
